import { FormattedMessage } from "react-intl"
import { FormSelect } from "@/components/Form/FormSelect"
import { FormTextInput } from "@/components/Form/FormTextInput"
import { type TransportDetailsFormInput } from "./TransportDetailsPanel"
import { meansOfTransport } from "@/model/transportation-report/transportation-report"

export const MeansOfTransport = () => {
    return <div
        className="display-flex gap-20 align-items-center justify-content-center padding-20 bg-lightest">
        <div className="padding-x-20 text-center ">
            <span className="text-size-16 text-color-gray">
                <span className="uikit-icon icon-truck text-size-200pct">
                </span>
            </span>
        </div>
        <div className={"flex-basis-100pct"}>
            <FormSelect
                fieldName={"transportDetails.transportMode.meansOfTransport"}
                label={<FormattedMessage id={"meansOfTransport.type"}/>}
                options={meansOfTransport.map(it => ({
                    id: it,
                    label: <FormattedMessage id={`meansOfTransport.type.${it}`}/>
                }))}
                required={true}
                validationMessageOverrides={{
                    required: <FormattedMessage id={"freightPaymentDetails.meansOfTransport.type.required"}/>
                }}
            />
        </div>
        <div className={"flex-basis-100pct"}>
            <FormTextInput<TransportDetailsFormInput>
                fieldName={"transportDetails.transportMode.licensePlate"}
                label={<FormattedMessage id={"licensePlate"}/>}
                required={true}
                validationMessageOverrides={{
                    required: <FormattedMessage id={"freightPaymentDetails.licensePlate.required"}/>
                }}
            />
        </div>
    </div>
}

